export const ContourLines = ({ className = "", opacity = 0.5 }) => (
  <svg
    className={className}
    viewBox="0 0 800 600"
    fill="none"
    aria-hidden="true"
    preserveAspectRatio="xMidYMid slice"
    style={{ opacity }}
  >
    {[
      "M-40,120 C180,60 320,200 540,140 C700,95 780,180 860,130",
      "M-40,200 C160,140 340,280 560,220 C720,175 800,260 870,210",
      "M-40,280 C140,220 360,360 580,300 C740,255 820,340 880,290",
      "M-40,360 C120,300 380,440 600,380 C760,335 840,420 890,370",
      "M-40,440 C100,380 400,520 620,460 C780,415 860,500 900,450",
      "M-40,520 C80,460 420,600 640,540 C800,495 880,580 910,530",
    ].map((d, i) => (
      <path key={i} d={d} stroke="#183F3A" strokeOpacity="0.14" strokeWidth="1" />
    ))}
    <path
      d="M300,300 l60,-40 l90,30 l20,70 l-80,50 l-90,-30 z"
      stroke="#C56D42"
      strokeOpacity="0.5"
      strokeWidth="1.5"
      strokeDasharray="4 4"
    />
    <circle cx="300" cy="300" r="4" fill="#C56D42" fillOpacity="0.7" />
    <circle cx="450" cy="290" r="4" fill="#C56D42" fillOpacity="0.7" />
    <circle cx="390" cy="410" r="4" fill="#C56D42" fillOpacity="0.7" />
  </svg>
);
